import React from 'react';
import { X } from 'lucide-react';
import { getCanonicalTag } from '../../utils/tagNormalizer';

interface InspectionTagBadgeProps {
  tagName: string;
  canonicalTag?: string | null;
  color?: string;
  onRemove?: () => void;
  clickable?: boolean;
  onClick?: () => void;
}

export const InspectionTagBadge: React.FC<InspectionTagBadgeProps> = ({
  tagName,
  canonicalTag,
  color = '#23211d',
  onRemove,
  clickable = false,
  onClick
}) => {
  // Auto-compute canonical tag if not provided
  const canonical = canonicalTag ?? getCanonicalTag(tagName);
  
  // Format display: "CANONICAL | variant" or just "tagName"
  const displayText = canonical && canonical.toUpperCase() !== tagName.toUpperCase().trim()
    ? `${canonical} | ${tagName}`
    : tagName;
    
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '4px 8px',
        borderRadius: '6px',
        fontSize: '0.75rem',
        fontWeight: '600',
        backgroundColor: `${color}20`,
        color: color,
        border: `1px solid ${color}40`,
        cursor: clickable ? 'pointer' : 'default',
        transition: 'all 0.2s'
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        if (clickable) {
          e.currentTarget.style.backgroundColor = `${color}30`;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = `${color}20`;
      }}
    >
      {displayText}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          style={{
            background: 'none',
            border: 'none',
            padding: '2px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            color: 'inherit',
            opacity: 0.7,
            transition: 'opacity 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '1';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '0.7';
          }}
        >
          <X size={12} />
        </button>
      )}
    </span>
  );
};
